<div class="sa-list">
  <split-card
    *ngFor="let item of items"
    theme="secondary">
    <ng-container card-header>
      <article class="sa-card" [attr.aria-label]="'Envio para contabilidade: ' + item.professionalName">
        <header class="sa-card__header">
          <div class="sa-card__title">
            <strong class="sa-card__name" appCamelCaseText>{{ item.professionalName }}</strong>
            <span class="sa-card__id">#{{ item.professionalId }}</span>
          </div>
        </header>

        <section class="sa-card__body">
          <div class="sa-card__column">
            <span class="sa-card__label">Email</span>
            <span class="sa-card__value">{{ item.email }}</span>
          </div>

          <div class="sa-card__column">
            <span class="sa-card__label">Vendas enviadas</span>
            <strong class="sa-card__value">{{ item.quantitySent }}</strong>
          </div>

          <div class="sa-card__column sa-card__column--highlight">
            <span class="sa-card__label">Vendas não enviadas</span>
            <strong class="sa-card__value text-primary">{{ item.quantityPending }}</strong>
          </div>

          <div class="sa-card__column sa-card__column--action">
            <span class="sa-card__label">Baixar vendas</span>
            <p-button
              ariaLabel="Baixar vendas"
              pTooltip="Baixar vendas"
              tooltipPosition="top"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              styleClass="sa-card__action-button sa-card__action-button--download"
              [loading]="downloadingCsvFor === item.professionalId"
              (click)="downloadCsvClick.emit(item)">
              <ng-template pTemplate="icon">
                <split-icon name="arrow-bar-to-down" size="20"></split-icon>
              </ng-template>
            </p-button>
          </div>

          <div class="sa-card__column sa-card__column--action">
            <span class="sa-card__label">Reenviar vendas</span>
            <p-button
              ariaLabel="Reenviar vendas"
              pTooltip="Reenviar vendas"
              tooltipPosition="top"
              [rounded]="true"
              [text]="true"
              severity="primary"
              styleClass="sa-card__action-button sa-card__action-button--send"
              (click)="sendEmailClick.emit(item)">
              <ng-template pTemplate="icon">
                <split-icon name="arrow-up-right" size="20"></split-icon>
              </ng-template>
            </p-button>
          </div>
        </section>
      </article>
    </ng-container>
  </split-card>
</div>
